module.exports = __webpack_public_path__ + "static/logo.94923daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/logo.png
// module id = 396
// module chunks = 35783957827783